export default "__VITE_ASSET__D9_PxQn9__"